// extracted by mini-css-extract-plugin
module.exports = {"resume__list-item":"ProfileResume_resume__list-item__ta2F4","resume__title":"ProfileResume_resume__title__tMNxU","resume__text":"ProfileResume_resume__text__OMErU"};